import { Request } from "../../utils/request";

export const fetchProductsCategory = () =>
  Request({ withToken: true }).get("/products-category/?join=products");

export const fetchProductsCategoryStrict = () =>
  Request({ withToken: true }).get("/products-category/?join=products");
